import React from "react";
import { Rating, Skeleton, Stack } from "@mui/material";

// Icon
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
const MyOrderReturnRatingSkeleton = () => {
  return (
    <Stack spacing={2}>
      <div className="return-product">
        <Skeleton animation="wave" width="60%" />
      </div>
      <div className="product-rating">
        <p>Rate Product</p>
        <Rating
          name="order-product-rating"
          className="order-product-rating"
          icon={<StarRateRoundedIcon fontSize="inherit" />}
          emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
        />
      </div>
    </Stack>
  );
};

export default MyOrderReturnRatingSkeleton;
